<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	// Partials
	import MultiGroups from '@/Partials/Sport/Manage/MultiControl/_MultiGroups.svelte';
	import Manage from '@/Partials/Sport/Manage/MultiControl/_Manage.svelte';

	export let sport;
	export let tab;
</script>

<div>
	<div class="flex items-center justify-center w-full">
		<div class="btn-group">
			<Link
				href={`/sport/manage/${sport.id}/multi`}
				class="btn {tab === undefined || tab === null ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Manage Exclusions
			</Link>
			<Link
				href={`/sport/manage/${sport.id}/multi/groups`}
				class="btn {tab === 'groups' ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Multi Groups
			</Link>
		</div>
	</div>
	{#if sport}
		{#if tab === 'groups'}
			<MultiGroups bind:sport />
		{:else}
			<Manage bind:sport />
		{/if}
	{/if}
</div>
